
    import { Component, Vue, Prop } from 'vue-property-decorator';
    
    import { stepInfoType } from "@/types/Application";
    import StepBase from "@/components/steps/StepBase.vue";
    
    import FilingOptions from "./FilingOptions.vue";
    import ReviewAndPrint from "./ReviewAndPrint.vue";
    import ReviewAndSave from "./ReviewAndSave.vue";
    import ReviewAndSubmit from "./ReviewAndSubmit.vue";
    import OtherFile from "./OtherFile.vue";
    import ResubmitAttachments from "./ResubmitAttachments.vue"
    import NextSteps from "./NextSteps.vue";

    import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

    import { namespace } from "vuex-class";   
    import "@/store/modules/application";
    const applicationState = namespace("Application");

    @Component({
        components:{
            StepBase,
            FilingOptions,
            ReviewAndPrint,
            ReviewAndSave,
            ReviewAndSubmit,
            OtherFile,
            ResubmitAttachments,
            NextSteps
        }
    })

    export default class StepSubmit extends Vue {
        
        @Prop({required: true})
        step!: stepInfoType;

        @applicationState.State
        public stPgNo!: stepsAndPagesNumberInfoType;
        
    }
